module.exports.version = 'v11.8.1-b82eed9b';
